export const lang = {
    DuplicateReference: "复制引用",
    routine: {//常规

        ecxcelFileSize: "文件大小不得超过",
        fileUploadError: "文件上传失败,请确保文件格式正确！",
        EnglishWebsiteAddress: "尚未配置英文网站地址，请通知管理员配置!",
        piece: "篇",
        jian: "件",
        ge: "个",
        ben: "本",
        term: "项",
        UploadFileNoMoreThan: "上传文件不超过1.5M",
        clickUpload: "点击上传",
        DragTheFileHere: "将文件拖到此处，或",
        uploadFileFail: "上传文件失败！",
        ClaimReviewInProgress: "认领审核中",
        AddingAndPpproving: "新增审核中",
        details: "详情",
        cancel_claim_results: "撤回认领",
        Claim: "确定认领",
        exitClaim: "退出认领",
        claimResults: "认领成果",
        youHavenAavedYetAreYouSureToLeave: "您尚未保存，确定离开？",
        supplementary: "在这里您可以编辑补充说明的内容",
        pleaseEnterContent: "请编辑内容",
        pleaseEnterTheTitleOfTheArticle: "请编辑标题",
        goBack: "返回",
        UserManual: "使用手册",
        personalCenter: "个人中心",
        loginOut: "退出登录",
        modifySuccessfullyAboutToJumpToLoginPage: "修改成功即将跳往登陆界面",
        determine: "确定",
        add: "添加",
        cancel: "取消",
        submission: "提交",
        preservation: "保存",
        close: "关 闭",
        search: "搜索",
        reset: "重置",
        delete: "删除",
        tips: "提示",
        areYouSureYouWantToDelete: "确定要删除吗？",
        batchDeletion: "批量删除",
        recovery: "恢复",
        remarksDetails: "备注详情",
        SupplementaryContent: "补充内容",
        EditSupplementaryContent: "编辑补充内容",
        pleaseEnterKeywords: "请输入关键字",
        startDate: "开始日期",
        to: "至",
        endDate: "结束日期",
        queryField: "查询字段",
        edit: "编辑",
        display: "显示",
        displayMedium: "显示中",
        hide: "隐藏",
        hidden: "隐藏中",
        dataStatistics: "数据统计",
        noData: "暂无数据",
        batchRecovery: "批量恢复",
        exhibition: "展示",
        desperatelyLoading: "拼命加载中",
        hidden: "隐藏中",
        displayMedium: "显示中",
        areYouSureYouWantToSetUpAPresentation: "确定要设置展示吗？",
        areYouSureYouWantToSetHide: "确定要设置隐藏吗？",
        areYouSureYouWantToRestore: "确定要恢复吗？",
        status: "状态",
        operation: "操作",
        newlyAdded: "新增",
        pleaseChoose: "请选择",
        pleaseEnterTheWebAddress: "请输入网址",
        pleaseEnterSource: "请输入来源",
        selectionDate: "选择日期",
        pleaseSelectDataItem: "请选择数据项！",
        yes: "是",
        no: "否",
        start_1: "起",
        end_1: "止",
        youSelectedRepeat: "请检查您选择的作者是否有重复！"
    },

    tabPage: {//标签页
        tabOptions: "标签选项",
        closeOther: "关闭其他",
        closeAll: "关闭所有",
    },
    index: {//主页
        goodMorning: "早上好",
        teacher: "老师",
        fullName: "姓名",
        personalInformation: "个人信息",
        positionalTitles: "职称",
        duties: "职务",
        education: "学历",
        mailbox: "邮箱",
        telephone: "电话",
        paper: "论 文",
        patents: "专 利",
        honor: "荣 誉",
        work: "作品著作",
        software: "软件著作",
        project: "项 目"
    },
    researchProgress: {//研究成果
        type: "类型",
        TitleMismatch: "标题不符",
        TimeDiscrepancy: "时间不符",
        AuthorDiscrepancy: "作者不符",
        ContentDiscrepancy: "内容不符",
        Other: "其他",
        pleaseAuthorList: "请输入作者列表",
        authorList: "作者",
        pic: "图片",
        quote_file: "引用文件",
        see: "查看",
        ViewNotes: "查看备注",
        researchProgress: "研究成果",
        recycleBin: "回收站",
        exitRecycleBin: "退出回收站",
        numberOfAuthorsCannotBeZero: "作者数量不能为零",
        source: "来 源",
        website: "网 址",
        author: "作 者",
        uploadsPeople: "上传者",
        status: "状态",
        serialNumber: "序 号",
        name: "名 称",
        pleaseSelectAuthorName: "请选择作者名",
        newAuthor: "新增作者",
        MembersOfAssociationGroup: "关联组内成员",
        PleaseSelectAnAssociatedAuthor: "请选择关联作者",
        Audit: "审核",
        RevokeAudit: "撤销审核",
        SubmitAudit: "提交审核",
        ToBeAudited: "待审核",
        NotPass: "未通过/回退",
        pleaseEnterAuthorName: "请输入作者名称",
        synchronizeToResearchGroup: "同步到课题组",
        pleaseChooseWhetherToSynchronize: "请选择是否同步",
        Between2And500CharactersInLength: "长度在 2 到 500 个字符",
        paper: {//论文
            titleOfPaper: "论文名称",
            typesOfPapers: "论文类型",
            publicationTime: "发表时间",
            pleaseEnterThePaperName: "请输入论文名称",
            thesisCategory: "论文类别",
            pleaseEnterPublicationTime: "请输入发表时间",
            pleaseSelectPaperType: "请选择论文类型",

        },
        honor: {//荣誉
            honorName: "荣誉名称",
            honorLevel: "荣誉级别",
            winningTime: "获奖时间",
            pleaseEnterHonorName: "请输入荣誉名称",
            pleaseSelectHonorLevel: "请选荣誉级别",
            pleaseEnterTheAcquisitionTime: "请选荣誉级别",
        },
        patents: {//专利
            inventor: "发明人",
            PleaseInventor: "请输入发明人列表",
            patentName: "专利名称",
            patentType: "专利类别",
            authorizedAnnouncementDate: "公开日",
            pleaseEnterThePatentName: "请输入专利名称",
            pleaseEnterTheAuthorizedAnnouncementDate: "请输入公开日",
            pleaseSelectPatentCategory: "请选择专利类别",
            applicationNumber: "授权号",
            pleaseEnterTheApplicationNumber: "请输入授权号",
        },
        work: {//著作
            titleOfWorks: "著作名称",
            publishingTime: "出版时间",
            pleaseEnterTheTitleOfTheWork: "请输入著作名称",
            pleaseSelectPublishTime: "请选择出版时间",
            registrationMark: "登记号",
            pleaseEnterTheRegistrationMark: "请输入登记号"
        }
    },
    project: {//科研项目
        researchProject: "科研项目",
        projectName: "项目名称",
        projectLevel: "项目级别",
        applicant: "申请人",
        timeFrame: "时间范围",
        pleaseEnterProjectName: "请输入项目名称",
        pleaseSelectProjectLevel: "请选择项目级别",
        pleaseEnterTheNameOfTheApplicant: "请输入申请人名称",
        pleaseSelectAStartTime: "请选择开始时间",
        pleaseSelectAEndTime: "请选择结束时间",
        startTimeCannotBeGreaterThanEndTime: "开始时间不能大于结束时间",
        project_source: "项目来源",
        approved_amount: "获批金额",
        enterProjectSource: "请输入项目来源",
        enterApprovedAmount: "请输入获批资金",
        personInCharge: "项目负责人",
        enterPersonInCharge: "请输入项目负责人"
    },
    password: {//修改密码
        changePassword: "修改密码",
        originalPassword: "原始密码",
        newPassword: "新密码",
        confirmPassword: "确认密码",
        submitRevision: "提交修改",
        pleaseEnterTheOriginalPassword: "请输入原始密码",
        pleaseEnterNewPassword: "请输入新密码",
        pleaseConfirmThePassword: "请确认密码",
        theNewPasswordEnteredTwiceIsInconsistent: "两次输入新密码不一致"
    },
    version: {
        ReleaseNotes: "版本说明",
        str1: "版本更新提示",
        str2: "版本发布时间",
        str3: "版本更新内容",
        content1: "增加用户独立系统主题配置",
        content2: "进展，项目以及部分模块具体化",
        content3: "以及修复BUG"
    },
    theme: {
        SwitchTheTheme: "切换主题",
        ChooseADefaultTheme: "请选择一种默认主题",
        PleaseConfirm: "请确认是否已保存主题配置！",
        PleaseSelect: "请先选中自定义主题",
        SaveTheConfiguration: "保存配置",
        mainColor: "主色",
        ComplementaryColor: "辅助色",
        CustomTheme: "自定义主题：",
        defaultTheme: "默认主题：",
        topicConfiguration: "主题配置",
        Newbie_Taskr: '新手引导',

        first_step: '第一步',
        second_step: '第二步',
        third_step: '第一步',
        Configure_personal_information: '配置个人信息',
        Configure_personal_information_container: '请填写个人信息，根据您的实际情况，添加、修改、删除、或隐藏部分信息，还可以对个人信息部分进行排序操作',
        Add_research_progress: '添加研究成果',
        Add_research_progress_container: '请填写研究成果，可以按照论文、专利、荣誉、著作等类型，根据您的实际情况，添加、修改、删除、或设置是否展示等操作。',
        Add_research_projects: '添加科研项目',
        Add_research_projects_container: '请填写研究成果，根据您的实际情况，添加、修改、删除、搜索或设置是否展示等操作。',
        catalog: '目录',
        basic_operation: '基本操作',
        Create_a_research_group: '创建课题组',
        Join_the_research_group: '加入课题组',
        Visit_the_personal_center: '访问个人中心',
        Personal_homepage_management: '个人主页的管理',
        Management_of_research_progress: '研究成果的管理',
        Management_of_scientific_research_projects: '科研项目的管理',
        change_password: '修改密码',
        imprint: '版本说明',
        operation_manual: '操作手册',
        Enter_the_url: '进入网址',
        Enter_the_url_container: '按步骤创建课题组，创建需提供课题组的域名等信息，创建成功后即可获得课题组网站链接和超级管理员的账号密码。',
        If_you_need_to_join_an_existing_research_group: '需加入已存在的课题组时，请咨询课题组管理员获得「网站链接」，访问链接通过注册功能填写信息，等待管理员审核通过即可成功加入该课题组。',
        Only_the_super_administrator_account: '只有超级管理员账号和获得管理员权限的账号有权访问网站管理端，用户可以在电脑端登陆后通过右上角「用户名称」下的个人中心进入「个人中心后台」。',
        After_entering_the_background_of_the_personal_center: '进入「个人中心后台」后，用户可以从左侧菜单栏访问「个人主页」，跳转到个人主页的编辑模式中。',
        Click_the_sorting_button_in_the_head_to_sort_the_basic_information_in_the_main_area: '点击头部的排序按钮即可将主区域内的基本信息、个人简介、研究方向等独立模块进行排序的操作。',
        Click_the_edit_or_exit_edit_button_in_the_header: '点击头部的编辑或退出编辑按钮，即可控制页面主区域的按钮的显示和隐藏。',
        Click_the_edit_button_in_front_of_each_small_module: '点击各小模块前的编辑按钮，即可单独进入该模块的编辑模式。',
        Click_the_show_or_hide_button_in_front_of_each_small_module: '点击各小模块前的显示/隐藏按钮，即可控制显示或隐藏该模块的展示。',
        After_editing_a_small_module: '当对某个小模块编辑完成后通过点击小模块上方的保存按钮，即可保存当前输入的信息。',
        After_entering_the_background_of_personal_center: '进入「个人中心后台」之后，用户可从左侧菜单栏访问「研究成果」，对个人的论文、专利、荣誉、著作等进行添加、编辑、删除和是否在门户展示等操作。',
        After_entering_the_background_of_the_personal_center_o: '进入「个人中心后台」后，用户可以从左侧菜单栏访问「科研项目」，对个人的科研项目进行添加、编辑、删除和是否在门户展示等操作。',
        After_entering_the_background_of_the_personal_center_s: '进入「个人中心后台」后，用户可以从左侧菜单栏访问「修改密码」，对本人的账号密码进行修改的操作。',
        After_entering_the_background_of_the_personal_center_D: '进入「个人中心后台」后，用户可以从左侧菜单栏访问「版本说明」，对课题组的当前版本信息和优化信息进行了解。',
        After_entering_the_background_of_the_personal_center_F: '进入「个人中心后台」后，用户可以从左侧菜单栏访问「操作手册」，了解熟悉个人中心管理系统的基本操作。',
    },
    titleConfig: {
        Thickening: "加粗",
        Italics: "斜体",
        Underline: "下划线",
        formatParagraph: "段落格式",
        Strikeout: "删除线",
        BlockReference: "块引用",
        InsertCode: "插入代码",
        InsertSnippet: "插入代码段",
        Typeface: "字体",
        fontSize: "字体大小",
        NumberedList: "编号列表",
        ProjectList: "项目列表",
        TextDirection: "文本方向",
        Alignment: "对齐方式",
        FontColor: "字体颜色",
        backgroundColor: "背景颜色",
        image: "图像",
        video: "视频",
        AddLink: "添加链接",
        InsertFormula: "插入公式",
        ClearFontFormat: "清除字体格式",
        subscript: "下标",
        Superscript: "上标",
        IndentLeft: "向左缩进",
        IndentRight: "向右缩进",
        TitleSize: "标题大小",
        TitleI: "标题一",
        TitleII: "标题二",
        TitleThree: "标题三",
        TitleIV: "标题四",
        TitleFive: "标题五",
        TitleVI: "标题六",
        standard: "标准",
        trumpet: "小号",
        Tuba: "大号",
        extraLargeSize: "超大号",
        AlignLeft: "居左对齐",
        AlignCenter: "居中对齐",
        AlignRight: "居右对齐",
        Justify: "两端对齐",
        file: "文件",
    },
    Recent_Visitors:"最近访客",
    Quote:"引用",
    Browse:"浏览",
    Established_project_time:"立项时间",
    awesome:"赞",
    Source_File:"源文件",
    Application_number:"申请编号",
    Cited_content:"引用内容",
    reference_materials:"引用文件",
    Inquire:"查 询",
    Show_table:"显示表格",
    Hide_table:"隐藏表格",
    Download_source_files:"下载源文件",
    Add_keywords:"新增关键词",
    Starting_time:"开始时间",
    member:"成员",
    Academic_organization:"学术组织",
    home: "首页",
    Go_to_home: "去首页",
    Registration_is_deemed_consent: "注册即视为同意",
    protocol_of_usage: "使用协议",
    pageview: '阅读',
    link_suffix: '个人链接',
    release: "发布者",
    details: "详情",
    Upload_time: "上传时间",
    Ordering_module: "排序模块",
    Edit_your_basic_information: "编辑基本信息",
    Hide_the_module: "隐藏该模块",
    Display_the_module: "显示该模块",
    Hide_module: "隐藏模块",
    Display_module: "显示模块",
    cancel: "取 消",
    confirm: "确 定",
    delete: "删 除",
    editor: "编辑",
    save: "保存",
    name: "姓名",
    Date_of_birth: "出生日期",
    identity: "身份",
    The_title: "职称",
    position: "职务",
    The_phone: "电话",
    fax: "传真",
    E_mail: "电子邮件",
    address: "地址",
    education_background: "学历",
    Click_change_image: "点击更换图片",
    Crop_Image: "裁剪图片",
    Personal_profile: "基本信息",
    The_module_is_hidden_and_will_not_appear_on_the_home_page: "模块已隐藏，将不会在主页显示",
    biography: "个人简介",
    No_biography_at_present: "暂无个人简介",
    research_direction: "研究方向",
    Add_research_direction: "添加研究方向",
    Modify_research_direction: "修改研究方向",
    Add_a_new_project: "添加新内容",
    Education_experience: "教育经历",
    Add_educational_experience: "添加教育经历",
    Revise_your_education: "修改教育经历",
    The_start_time: "开始时间",
    Please_select_date: "请选择日期",
    The_end_of_time: "结束时间",
    Up_to_now: "至今",
    school: "学校",
    Please_enter_the_school_name: "请输入学校名称",
    degree: "学位",
    research_experience: "科研经历",
    Add_research_experience: "添加科研经历",
    Revise_research_experience: "修改科研经历",
    unfold: "展开",
    thesis_scores: "论文成果",
    Pack_up: "收起",
    Authorized_patents: "授权专利",
    Undergoing_Research_Projects: "承担科研项目",
    work: "著作",
    Honor_rewards: "荣誉奖励",
    The_information_of_the_person_in_charge_that_is_pushed_in_the_team_introduction_under_the_website_management_will_be_displayed_here: "在网站管理-团队介绍中被推送的负责人资料会显示在这里",
    menu: "菜单",
    menu_zh: "MENU",
    research_dynamic: "科研动态",
    research_dynamic_zh: "RESEARCH",
    news_and_trends: "新闻动态",
    news_and_trends_zh: "NEWS",
    more: "查看更多",
    No_dynamic: "暂无动态",
    screening: "筛选",
    screening_zh: "FILTER",
    filter: "筛选条件",
    All_dynamic: "全部动态",
    About_us: "关于我们",
    Contact_us: "联系我们",
    email: "邮箱",
    postcode: "邮编",
    blogroll: "友情链接",
    Social_media: "社交媒体",
    return: "返回",
    Module_sorting: "模块排序",
    Exit_the_editor: "退出编辑",
    website_management: "网站管理",
    Personal_center: "个人中心",
    personal_homepage: "个人主页",
    research_achievements: "科研成果",
    Log_out: "退出登录",
    login: "登录",
    register: "注册",
    Personal_introduction: "个人介绍",
    Personal_introduction_zh: "PERSONAL INTRODUCTION",
    Introduction_to_the_research_group: "课题组介绍",
    Introduction_to_the_research_group_zh: "INTRODUCTION",
    // research_direction:"研究方向",
    research_direction_zh: "RESEARCH DIRECTION",
    achievement_exhibition: "成果展示",
    achievement_exhibition_zh: "RESEARCH",
    dynamic: "动态",
    dynamic_zh: "ACTIVITIES",
    research_equipment: "科研设备",
    research_equipment_zh: "EQUIPMENT",
    member_introduction: "成员介绍",
    member_introduction_zh: "PEOPLE",
    Research_group_management_system: "课题组管理系统",
    Please_enter_your_user_name_or_email_address: "请输入用户名或邮箱",
    Please_enter_your_password: "请输入密码",
    Verification_code: "验证码",
    reload: "重新加载",
    Try_a_different_image: "换一张",
    Go_to_register: "去注册",
    Registered_account: "注册账号",
    Mailbox_verification_code: "邮箱验证码",
    send: "发送",
    password: "密码",
    Confirm_password: "确认密码",
    User_identity: "用户身份",
    Please_select_user_identity: "请选择用户身份",
    To_log_in: "去登录",
    See_more_years: "查看更多年份",
    honor: "荣誉",
    paper: "论文",
    patent: "专利",
    Patents: "软著",
    All_the_time: "全部时间",
    language: "English",
    previous_posts: "上一篇",
    next_chapter: "下一篇",
    share: '分享',
    copy_href: '复制当前地址',
    source: '来源',
    Project_Time: '项目时间',
    external_links: '外部链接',
    gainer: '获得者',
    writer: '作者',
    announcer: '发布者',
    Hide: '隐藏',
    Display: '显示',
    No_data: '暂无数据',
    Please_enter_the_content: '请输入内容',
    tryingToUpload: "拼命上传中...",
    selectFile: "选取文件",
    pictureInsertionFailed: "图片插入失败",
    delete: "删除",
    new_module: "新增模块",
    title: "标题",
    Please_enter_your_title: "请输入标题",
    Revise_your_profile: "修改个人简介",
    Add_custom_templates: "添加自定义模板",
    modification: "修改",
    Software: "软件著作",
    All: "全部",
    researchprogress: "研究成果",
    DownloadTheReference: "下载引用",
    principalIntroduce: "课题组负责人",
    Thecloudteam: '云课题组',


};


// WEBPACK FOOTER //
// ./src/VueI18n/language-zh.js